import { Grid } from "@material-ui/core";
import { HeaderData } from "./components/HeaderData";
import { EAFChart } from "./components/charts/eaf-chart/EAFChart";
import { AdditionsTable } from "./components/tables/additions-table/AdditionsTable";
import { ChargesTable } from "./components/tables/charges-table/ChargesTable";
import { DelaysTable } from "./components/tables/delays-table/DelaysTable";
import { HeatingsTable } from "./components/tables/heatings-table/HeatingsTable";
import { ProbesTable } from "./components/tables/probes-table/ProbesTable";

export const EAFProcessData = () => {
	return (
		<>
			<Grid item xs={12} container spacing={1} justifyContent="center">
				<Grid item xs={12} container spacing={1}>
					<HeaderData />
				</Grid>
			</Grid>

			<Grid item xs={12} container spacing={1} justifyContent="center">
				<Grid item xs={3}>
					<AdditionsTable />
				</Grid>
				<Grid item xs={3}>
					<ProbesTable />
				</Grid>
				<Grid item xs={3}>
					<ChargesTable />
				</Grid>
				<Grid item xs={3}>
					<HeatingsTable />
				</Grid>
			</Grid>
			<Grid item xs={12} container spacing={1}>
				<Grid item xs={12}>
					<EAFChart />
				</Grid>
			</Grid>
			<Grid item xs={12} container spacing={1}>
				<Grid item xs={12}>
					<DelaysTable />
				</Grid>
			</Grid>
		</>
	);
};
